<template>
  <div ref="div">
    <loader :show-loader="loading"></loader>
    <div v-show="!loading" class="main-content text-center">
      <div class="dropzone" :class="file !== undefined ? 'dropzone-success' : ''">
        <div class="dz-message">
          <div class="icon">
            <span class="s7-cloud-upload"></span>
          </div>
        </div>

        <label>
          <strong class="drag-and-drop-label">{{ label }}</strong>
          <input type="file" name="file" id="file" :accept="accept" @input="onFileChange"/>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
  import imageCompression from 'browser-image-compression';

  export default {
    name: 'simple-drag-and-drop',

    props: {
      label: {
        type: String,
        default: 'Selecione ou arraste um arquivo'
      },

      accept: {
        type: String,
        default: '*'
      },

      shouldResize: {
        default: () => false,
      }
    },

    data() {
      return {
        file: undefined,
        progress: 0,
        loading: false,
        dragAndDropCapable: true,
        features: ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop']
      }
    },

    mounted() {
      this.verifyFunctionalityInBrowser();
    },

    methods: {
      onFileChange(event) {
        this.loading = true;

        let files = event.target.files || event.dataTransfer.files;
        if (!files.length) {
          return this.loading = false;
        }

        let file = files[0];
        if (this.shouldResize && this.accept.indexOf(file.type) !== -1) {
          const options = { maxSizeMB: 1, maxWidthOrHeight: 1024, useWebWorker: true, maxIteration: 50 };
          return imageCompression(files[0], options).then((compressedFile) => {
            file = compressedFile;
            this.readFile(file);
            this.loading = false;
          })
        } else {
          this.$root.throwFlashMessage('error', 'Verifique o tipo e extensão da imagem!');
          this.loading = false;
        }
      },

      readFile(file) {
        let reader = new FileReader();

        reader.onload = (e) => {
          let result = e.target.result;

          this.emitFileEvent(result, file.type);
        };
        reader.readAsDataURL(file);
      },

      emitFileEvent(base64, fileType) {
        this.$root.$emit('sending-back-base64', {
          base64,
          fileType
        });
      },

      removeFile() {
        this.progress = 0;
        this.file = undefined;
      },

      verifyFunctionalityInBrowser() {
        const {div} = this.$refs;
        this.dragAndDropCapable = this.isDragAndDropCapable();

        if (this.dragAndDropCapable) {
          this.features.forEach(event => {
            document.body.addEventListener(event, e => {
              e.preventDefault();
              e.stopPropagation();
            });
          });

          div.addEventListener('drop', e => {
            this.onFileChange(e)
          })
        }
      },

      isDragAndDropCapable() {
        const {div} = this.$refs;

        return (('draggable' in div)
          || ('ondragstart' in div && 'ondrop' in div))
          && 'FormData' in window
          && 'FileReader' in window
      },
    }
  }
</script>

<style scoped>
  input[type="file"] {
    display: none;
  }

  .dropzone-success {
    border: 2px dashed #2d7cff;
  }

  .dropzone {
    border: 2px dashed #c5c5c5;
    padding: 70px 60px 80px;
    background: 0 0;
  }

  .dropzone .icon {
    background-color: #e6e6e6;
    border-radius: 50%;
    height: 100px;
    width: 100px;
    margin-bottom: 15px;
    padding: 20px;
    text-align: center;
    display: inline-block;
  }

  .dropzone .icon span {
    font-size: 60px;
    color: #646262;
  }

  .drag-and-drop-label:hover {
    text-decoration: underline;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/SimpleDragAndDrop.vue